import React from "react";

const OrganiztionalManagment = () => {
  return (
    <div className="container mx-auto flex flex-col items-start justify-between px-4 lg:px-6 mb-0 z-30">
      <div data-aos="fade-right" className="flex flex-col my-12 gap-4">
        <p className="text-cls">
          Papa Giovanni XXIII dichiara di aver aggiornato il modello di
          organizzazione gestione e controllo in data 18/07/2025.
        </p>

        <div className="flex flex-col gap-2">
          <p className="text-left text-blue-text font-bold text-2xl">PARTE GENERALE</p>
          <a
            href="/images/documents/parte_generale_mogc.pdf" target="_blank" 
            className="flex flex-col justify-center items-center flex-grow  bg-blue-primary py-3 px-5 text-center w-fit"
          >
            <p className="leading-[1.5] w-full mx-auto text-white text-lg uppercase font-semibold">
              Visualizza il documento
            </p>
          </a>
        </div>

        <div className="flex flex-col gap-2">
          <p className="text-left text-blue-text font-bold text-2xl">CODICE ETICO</p>
          <a
            href="/images/documents/codice_etico.pdf" target="_blank"
            className="flex flex-col justify-center items-center flex-grow  bg-blue-primary py-3 px-5 text-center w-fit"
          >
            <p className="leading-[1.5] w-full mx-auto text-white text-lg uppercase font-semibold">
              Visualizza il documento
            </p>
          </a>
        </div>
        <p className="text-base text-left font-normal text-black">
          È possibile contattare l’Organismo di Vigilanza inviando una
          segnalazione tramite email a questo indirizzo dedicato:{" "}
          <a
            href="mailto:odv@xxiii.it"
            className="text-base font-medium text-blue-primary text-right underline"
          >
            odv@xxiii.it{" "}
          </a>
        </p>
      </div>
    </div>
  );
};

export default OrganiztionalManagment;
